module.exports = __webpack_public_path__ + "img/queluz_logo.d4551efe.png";